module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cf-eb50c5ecfa556ddba5a7a7e6cdd0c75e.svg";